import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {getCurrentUser, request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import DocumentForm from "./DocumentForm";
import {API_BASE_URL} from "../../constants";
import DocumentDeleteModal from "./DocumentDeleteModal";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import Icon from "antd/es/icon";
import "./DocumentList.css";
import moment from "moment/moment";
import DocumentInfo from "./DocumentInfo";
import DocumentNoteModal from "./DocumentNoteModal";
import DocumentIncomingModal from "./DocumentIncomingModal";

class DocumentList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            add: false,
            currentUser:[],
            userId: null,
            selectedDocument: null,
            selectedItem: null,
            branches: null,
            roles: null,
            documents: [],
            totalIdList: [],
            debtList: [],
            cities: null,
            citySubdivisions: null,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addDocumentModal: false,
            addNoteModal: false,
            addIncomingModal: false,
            addTransferModal: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
            action: '',
            isLoading: false,
            alert: null,
            transactionChannels: [],
            documentShipped: [],
            documentContent: [],
            documentInfoModal:false,
            subdivisions: [],
            count:0,
            read:{
                evrakId:0,
                isRead:0,
            },
        };

        this.listDocument = this.listDocument.bind(this);
        this.cancelDocumentCreation = this.cancelDocumentCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listCities = this.listCities.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleNote = this.handleNote.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.listRoles = this.listRoles.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.listDocumentTypes = this.listDocumentTypes.bind(this);
    }
    componentDidMount() {
        this.listCities();
        this.listBranches();
        this.listRoles();
        this.listDocumentTypes();
        this.listDocument(undefined, undefined, 0, this.state.size);
    }


  listDocumentTypes(accessor, direction) {
      let self = this;
      let sortStr = !!accessor ? ("&sort=" + accessor + ",desc") : "&sort=id,desc";
      this.setState({loading: true});

      getCurrentUser()
          .then(response => {
              let currentUser = response.data;
              this.setState({
                  currentUser: currentUser,
                  userId: currentUser.id,
                  loading: false
              });
          }).catch(() => {
              self.setState({loading: false, searching: false});
          });

      let url = API_BASE_URL + "/evrakSevk/forUser?" + sortStr; // Sıralama parametresini URL'ye ekle
      let params = {
          url: url,
          method: "get",
      };

      request(params)
          .then(function (response) {
              let documentShipped = response.data;
              // State güncellemelerini ve modal kontrolünü kaldırdık
          }).catch(function (error) {
              showAxiosError(error);
          });
  }


listDocument(accessor, direction, page, size) {
    let self = this;
    let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,desc"; // "desc" kullanarak ters sıralama
    let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
    let url = API_BASE_URL + "/evrakSevk/fetchEvrak?page=" + page + "&size=" + size + sortStr + searchQuery;

    let params = {
        url: url,
        method: "get",
    };

    self.setState({
        loading: true,
        manual: self.manual === true ? false : self.manual,
        searching: true
    });

    request(params)
        .then(function (response) {
            let documentShipped = (response.data) ? response.data.content : [];
            let totalIdList = response.data ? response.data.selectedIdList : [];
            let debtList = response.data ? response.data.debtList : [];

            // Sadece okunmamış belgeleri filtrele
            let unreadDocuments = documentShipped.filter(doc => doc.read === false);

            console.log("Okunmamış belgeler: ", unreadDocuments);

            self.setState({
                page: page,
                size: size,
                total: response.data.totalElements,
                documentShipped: documentShipped,
                totalIdList: totalIdList,
                debtList: debtList,
                loading: false,
                searching: false,
                // Modalın açılmasını kontrol eden kısım
                documentInfoModal: unreadDocuments.length > 0,
                count: unreadDocuments.length,
                unreadDocuments: unreadDocuments,
            }, () => {
                console.log("documentInfoModal state: ", self.state.documentInfoModal);
            });
        }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
}


    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/group/select",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let branches = response.data;
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    listRoles() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/select",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let roles = response.data;
                self.setState({
                    roles,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    listDocumentResultTypes() {
        this.setState({loading: true});
        let url;
        let data;
        data = this.state.read
        let evrakId = this.state.read.evrakId

        url = API_BASE_URL + "/evrakSevk/markAsRead?evrakId=" + evrakId
        let params = {
            url: url,
            data:data,
            method: "post",
        };
        request(params)
            .then(function (response) {
                console.log("isRead", response.data)

            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleLogout() {
        this.props.handleLogout();
    }
    cancelDocumentCreation() {
        this.setState({
            addDocumentModal: false,
            addNoteModal: false,
            addDeleteModal: false,
            add:false,
            addIncomingModal:false,
            // selectedDocument: null,
        })
        this.listDocumentTypes()
    }
    canceldocumentModal() {
        this.setState({
            documentInfoModal: false,
        })
    }
    handleRead(item) {
        let read = this.state.read;
        read.evrakId = item.id;
        read.isRead = 1;
        this.setState({
            selectedDocument: item,
            addDocumentModal: true,
            read
        })
        this.listDocumentResultTypes()
    }
    handleEdit(item) {
        this.setState({
            selectedDocument: item,
            addDocumentModal: true,
        })
        this.handleRead(item)
    }
    handleDelete(item) {
        this.setState({
            selectedDocument: item,
            addDeleteModal: true
        })
    }
    handleNote(item) {
        this.setState({
            selectedDocument: item,
            addNoteModal: true
        })
        this.handleRead(item)
    }

    handleIncoming(item) {
        this.setState({
            selectedDocument: item,
            addIncomingModal: true
        })
        this.handleRead(item)
    }

    handleInfo(item) {
        this.setState({
            selectedDocument: item,
            addIncomingModal: true,
        })
        this.handleRead(item)
    }
    addNew(item) {
        this.setState({
            selectedDocument: null,
            addDocumentModal: true,
            add:true
        })
    }
    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.listDocument(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleMenuClick(e) {
        let self = this;
        if (e.key === '1') {
            this.handleEdit(self.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(self.state.selectedItem);
        } else if (e.key === "3") {
            this.handleIncoming(self.state.selectedItem);
        } else if (e.key === "4") {
            this.handleNote(self.state.selectedItem);
        }
    }


    render() {
        let self = this;
        let branchSelectdata;
        let citySelectdata;
        const belgeTuru = [
            {value: null, label: "Tümü"},
            {value: 'DIPLOMA', label: "DİPLOMA"},
            {value: 'RUHSATNAME', label: "RUHSATNAME"},
            {value: 'GECICI_MEZUNIYET', label: "GEÇİCİ MEZUNİYET BELGESİ"},
        ];

        const menu = (
            <Menu onClick={self.handleMenuClick}>
                <Menu.Item key="3">
                    Gelen Evrak
                </Menu.Item>
                <Menu.Item key="1">
                    Evrak Düzenle
                </Menu.Item>
                <Menu.Item key="2">
                    Evrak Sil
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Evrak Adı",
                accessor: "evrakKonu",
            },
            {
                Header: "Evrak Türü",
                accessor: "belgeTuru",
            },
            {
                Header: "Evrak No",
                accessor: "evrakNo",
                // Cell: (item) => {
                //     return <label>
                //         {item.evrakNo}
                //     </label>
                // }
            },
            {
                Header: "İl",
                accessor: "Şanlıurfa",
                Cell: item => (
                    <label>Şanlıurfa</label>
                )
            },
            {
                Header: "Tarih",
                accessor: "sureBitisTarihi",
                // Cell: item => (
                //     <div style={{margin: "0px", fontSize: "12px"}}>
                //         {item.odaKayitTarihi ? "KT: " + new Date(item.odaKayitTarihi.toString()).toLocaleDateString('tr') : ""}
                //
                //         {item.uyelikSonlanmaTarihi ? <br/> : ""}
                //
                //         {item.uyelikSonlanmaTarihi ? "İKT: " + new Date(item.uyelikSonlanmaTarihi.toString().substring(0, item.uyelikSonlanmaTarihi.toString().indexOf('T'))).toLocaleDateString('tr') : ""}
                //
                //         {item.uyelikDondurmaTarihi ? <br/> : ""}
                //
                //         {item.uyelikDondurmaTarihi ? "ÜDT: " + new Date(item.uyelikDondurmaTarihi.toString().substring(0, item.uyelikDondurmaTarihi.toString().indexOf('T'))).toLocaleDateString('tr') : ""}
                //
                //     </div>
                //
                //
                // )
            },
            {
                Header: "Güncelleme Tarihi",
                accessor: "udate",
                Cell: item => (
                    <label>{moment.utc(item.udate).format("DD.MM.YYYY")}</label>)
            },
            {
                Header: "Evrak Giriş Tarihi",
                accessor: "cdate",
                Cell: item => (
                    <label>{moment.utc(item.cdate).format("DD.MM.YYYY")}</label>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu}
                                  trigger='click'
                                  onClick={() => self.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }

        ];

        const fields = [
            {
                label: "Evrak Adı",
                accessor: "evrakKonu",
                type: "text",
                operator: "=",
            },
            {
                label: "Tarih",
                accessor: "sureBitisTarihi",
                type: "date",
                operator: "=",
            },
            {
                label: "Evrak No",
                accessor: "evrakNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Evrak Türü",
                accessor: "belgeTuru",
                type: "select",
                operator: "=",
                selectData: belgeTuru,
            },
            // {
            //     label: "İl",
            //     accessor: "Şanlıurfa",
            //     type: "select",
            //     operator: "=",
            //     selectData: citySelectdata,
            // },
            // {
            //     label: "Mezuniyet Belge Tipi",
            //     accessor: "belgeTuru",
            //     type: "select",
            //     operator: "=",
            //     selectData: belgeTuru,
            // },

        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Evrak Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div>
                            <div style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.documentShipped}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listDocument}
                            style={{width:"100%"}}
                             getKey={(item) => item.id}
                        />

                    </div>
                    {
                        (this.state.mode !== 'review') &&
                            <div className="new-button-holder">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        title="Yeni Evrak Ekle" disabled={this.state.isLoading}
                                        style={{
                                            background: 'linear-gradient(#2b93cd, #0a66b7)',
                                            height: '40px',
                                            width: '160px',
                                            float: 'right',
                                            marginRight: '30px',
                                            color: 'white',
                                            borderRadius: '0.375em',
                                        }}
                                        className="TekBtn add-new-member "
                                        rel="tooltip"
                                        onClick={() => this.addNew(this.state.selectedItem)}>
                                    YENİ EVRAK EKLE
                                </button>
                            </div>
                    }
                </div>
                <Modal isOpen={this.state.documentInfoModal} size="lg" className="ust">
                    <ModalHeader toggle={() => this.canceldocumentModal()}>
                        {this.state.count} Yeni Gelen Evrak Mevcut
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DocumentInfo selectedDocument={this.state.selectedDocument}
                                      documentShipped={this.state.documentShipped}
                                      currentUser={this.props.currentUser}
                                      toggle={() => this.canceldocumentModal()}
                                      handleInfo={this.handleInfo}

                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDocumentModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDocumentCreation}>
                        {this.state.add
                            ?
                            'Yeni Evrak Ekleme'
                            :
                            'Evrak Düzenleme'
                        }
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DocumentForm cancelProcess={this.cancelDocumentCreation}
                                      selectedDocument={this.state.selectedDocument}
                                      currentUser={this.props.currentUser}
                                      mode={this.state.mode}
                                      module={this.props.name}
                                      cities={this.state.cities}
                                      citySubdivisions={this.state.citySubdivisions}
                                      handleSearch={this.handleSearch}
                                      searchQuery={this.state.searchQuery}
                                      branches={this.state.branches}
                                      roles={this.state.roles}
                                      handleLogout={this.handleLogout}
                                      documentFile={this.state.documentFile}
                                      getDocumentFile={this.getDocumentFile}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addNoteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDocumentCreation}>
                        Not Ekleme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DocumentNoteModal cancelProcess={this.cancelDocumentCreation}
                                           selectedDocument={this.state.selectedDocument}
                                           mode={this.state.mode}
                                           module={this.props.name} cities={this.state.cities}
                                           handleSearch={this.handleSearch}
                                           searchQuery={this.state.searchQuery}
                                           branches={this.state.branches}
                                           handleLogout={this.handleLogout}
                                           roles={this.state.roles}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addIncomingModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDocumentCreation}>
                        Gelen Evrak
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DocumentIncomingModal cancelProcess={this.cancelDocumentCreation}
                                           selectedDocument={this.state.selectedDocument}
                                           mode={this.state.mode}
                                           module={this.props.name} cities={this.state.cities}
                                           handleSearch={this.handleSearch}
                                           searchQuery={this.state.searchQuery}
                                           branches={this.state.branches}
                                           handleLogout={this.handleLogout}
                                           roles={this.state.roles}
                                           documentFile={this.state.documentFile}
                                           getDocumentFile={this.getDocumentFile}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDocumentCreation}>
                        Evrak Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DocumentDeleteModal cancelProcess={this.cancelDocumentCreation}
                                             selectedDocument={this.state.selectedDocument}
                                             handleLogout={this.handleLogout}/>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default DocumentList


// WEBPACK FOOTER //
// ./src/page/documentList/DocumentList.js